const REFERRAL_STORAGE_KEY = 'llp_referral_code';
const REFERRAL_ATTRIBUTION_TTL_MS = 90 * 24 * 60 * 60 * 1000;

function normalizeReferralCode(code) {
  return String(code || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function saveReferralCode(code) {
  const normalized = normalizeReferralCode(code);
  if (!normalized) {
    return false;
  }

  const payload = {
    code: normalized,
    savedAt: Date.now(),
    expiresAt: Date.now() + REFERRAL_ATTRIBUTION_TTL_MS,
  };

  try {
    localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(payload));
    return true;
  } catch (error) {
    console.warn('Unable to save referral code:', error);
    return false;
  }
}

export function getStoredReferralCode() {
  try {
    const raw = localStorage.getItem(REFERRAL_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const payload = JSON.parse(raw);
    if (!payload?.code || !payload?.expiresAt) {
      clearStoredReferralCode();
      return null;
    }

    if (Date.now() > payload.expiresAt) {
      clearStoredReferralCode();
      return null;
    }

    return normalizeReferralCode(payload.code);
  } catch (error) {
    clearStoredReferralCode();
    return null;
  }
}

export function clearStoredReferralCode() {
  try {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch (error) {
    console.warn('Unable to clear referral code:', error);
  }
}

export function captureReferralFromSearch(search = '') {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  const ref = params.get('ref');
  if (!ref) {
    return null;
  }

  saveReferralCode(ref);
  return normalizeReferralCode(ref);
}

export function getReferralAttributionDaysRemaining() {
  try {
    const raw = localStorage.getItem(REFERRAL_STORAGE_KEY);
    if (!raw) {
      return 0;
    }

    const payload = JSON.parse(raw);
    if (!payload?.expiresAt) {
      return 0;
    }

    const remainingMs = payload.expiresAt - Date.now();
    return Math.max(0, Math.ceil(remainingMs / (24 * 60 * 60 * 1000)));
  } catch (error) {
    return 0;
  }
}

export {
  REFERRAL_STORAGE_KEY,
  REFERRAL_ATTRIBUTION_TTL_MS,
  normalizeReferralCode,
};
